import AdminTeamMembersPage from "./AdminTeamMembersPage";

export default AdminTeamMembersPage;
